import moment from "moment";

import homeService from "Network/lib/homeService";
import vehicleService from "Network/lib/vehicleService";

import * as actionTypes from "./actionTypes";

export const getDataTableStart = () => ({
  type: actionTypes.GET_HOME_DATA_TABLE_START
});

export const getDataTableSuccess = (data) => ({
  type: actionTypes.GET_HOME_DATA_TABLE_SUCCESS,
  data
});

export const getVehicleFiltersStart = (data) => ({
  type: actionTypes.GET_VEHICLE_FILTERS_START,
  data
});

export const getVehicleFiltersSuccess = (data) => ({
  type: actionTypes.GET_VEHICLE_FILTERS_DATA,
  data
});

export const getVehicleFiltersFail = (data) => ({
  type: actionTypes.GET_VEHICLE_FILTERS_FAIL,
  data
});

export const getDataTableFail = () => ({
  type: actionTypes.GET_HOME_DATA_TABLE_FAIL
});

export const setUrl = (url) => ({
  type: actionTypes.SET_URL,
  data: url
});

export const getVehicleFilters = () => (dispatch) => {
  dispatch(getVehicleFiltersStart());

  return new Promise((resolve, reject) => {
    vehicleService
      .getFiltersV2()
      .then((response) => {
        dispatch(getVehicleFiltersSuccess(response));
        resolve(response);
      })
      .catch((err) => {
        dispatch(getVehicleFiltersFail());
        reject(err);
      });
  });
};

export const getData = (body) => (dispatch, getState) => {
  const {
    vehicle: {
      pagination: { currentPage, pageSize },
      sortOrder,
      searchText,
      criterias,
      isActive
    }
  } = getState();

  const payload = {
    sortOrder,
    sort: "date",
    pageLimit: pageSize,
    currentPage,
    searchText,
    criterias,
    // eslint-disable-next-line no-nested-ternary
    isActive: isActive === "ACTIVE" ? true : isActive === "INACTIVE" ? false : null,
    offset: currentPage === 1 ? 0 : (currentPage - 1) * 10,
    ...body
  };
  dispatch(getDataTableStart());
  return new Promise((resolve, reject) => {
    homeService
      .getDataTableV2(payload)
      .then((response) => {
        dispatch(getDataTableSuccess(response));
        resolve(response);
      })
      .catch((err) => {
        dispatch(getDataTableFail());
        reject(err);
      });
  });
};

export const setQRCode = (data) => ({
  type: actionTypes.SET_QR_CODE,
  data
});

const setFiltersData = (filters, criterias) => ({
  type: actionTypes.SET_FILTERS,
  filters,
  criterias
});

// export const setFilters = (filters) => ({
//   type: actionTypes.SET_FILTERS,
//   filters,
//   criterias
// });

export const setCurrentPage = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE,
  page
});

export const setFilters = (filters) => (dispatch) => {
  const list = Object.keys(filters).map((item) => {
    const currObj = filters[item];
    if (currObj.type === "DATE") {
      return {
        ...currObj,
        value:
          currObj.option === "IN_BETWEEN"
            ? [
                moment.utc(currObj.value[0]).add("1", "d").startOf("day").format(),
                moment.utc(currObj.value[1]).add("1", "d").endOf("day").format()
              ]
            : moment.utc(currObj.value[0]).add("1", "d").startOf("day").format()
      };
    }

    const orCriterias = [];

    currObj.values &&
      currObj.values.length > 0 &&
      currObj.values.forEach((x) => {
        if (currObj.values.includes(x.id)) {
          if (x.orCriterias) {
            orCriterias.push(...x.orCriterias);
          }
        }
      });

    return {
      ...currObj,
      orCriterias
    };
  });
  dispatch(setFiltersData(filters, list));
  dispatch(setCurrentPage(1));
  dispatch(getData());
};

export const setSearch = (text) => ({
  type: actionTypes.SET_SEARCH,
  text
});

export const setActive = (value) => ({
  type: actionTypes.SET_ACTIVE,
  value
});

export const setSortOrder = (value) => ({
  type: actionTypes.SET_SORT_ORDER,
  value
});
